import Professionals from "./professionals";
import ProfessionalCoupons from "./coupons";

export default {
  Professionals,
  ProfessionalCoupons
};



// WEBPACK FOOTER //
// ./src/API/modules/professionals/index.js